import { createAsyncState, createNormalizedEndpoint } from 'redux/helpers';
import { StandardAction } from 'redux/types';
import { executeWithObject } from 'utils/fp';

import { INotificationState } from '../types';
import NotificationAction from './notification.action';
import { INotification, NotificationStatus } from './types';

const initialState = {
  ...createAsyncState(createNormalizedEndpoint<INotification>()),
  isOpen: false,
};

const readNotification = (v: INotification) => ({ ...v, status: NotificationStatus.READ });
const readAll = executeWithObject.values(readNotification);

export default function (state = initialState, action: StandardAction): INotificationState {
  switch (action.type) {
    case NotificationAction.ACTION_TYPES.FETCH_NOTIFICATION: {
      return {
        ...state,
        data: createNormalizedEndpoint(action.payload),
      };
    }
    case NotificationAction.ACTION_TYPES.NEW_NOTIFICATION: {
      const newNotification: INotification = {
        ...(<INotification>action.payload),
        id: action.payload?.id || new Date().getTime(),
      };

      return {
        ...state,
        data: {
          allIds: [newNotification.id, ...state.data.allIds],
          byId: {
            ...state.data.byId,
            [newNotification.id]: newNotification,
          },
        },
      };
    }
    case NotificationAction.ACTION_TYPES.READ_NOTIFICATION: {
      return {
        ...state,
        data: {
          ...state.data,
          byId: {
            ...state.data.byId,
            [action.payload.id]: {
              ...action.payload,
              status: NotificationStatus.READ,
            },
          },
        },
      };
    }
    case NotificationAction.ACTION_TYPES.DELETE_NOTIFICATION: {
      const allIds = state.data.allIds.filter((id) => id !== action.payload.id);
      const byId = { ...state.data.byId };
      delete byId[action.payload.id];

      return {
        ...state,
        data: { allIds, byId },
      };
    }
    case NotificationAction.ACTION_TYPES.READ_ALL: {
      return {
        ...state,
        data: {
          ...state.data,
          byId: readAll<typeof state.data.byId, INotification>(state.data.byId),
        },
      };
    }
    case NotificationAction.ACTION_TYPES.DELETE_ALL: {
      return {
        ...state,
        data: { allIds: [], byId: {} },
      };
    }
    case NotificationAction.ACTION_TYPES.TOGGLE_NOTIFICATION: {
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    }
    default:
      return state;
  }
}
